/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React,{useRef,useState} from 'react'
import { useOnClickOutside } from '../../CommonMethods/OutsideClick';
import ErrorMessage from '../ErrorMessage';
import { SearchArrayData } from '../../CommonMethods/SearchArrayData';

export default function DropDown({
    label,
    isSearch,
    options,
    placeholder,
    divClassKey,
    handleDropdown,id,submitSelected,state,message}) {
    const [isOpen, setisOpen] = useState(false);
    const [search, setsearch] = useState('')
    const ref=useRef()
    useOnClickOutside(ref, 
        () => {
            setisOpen(false);
        }
    )
    return (
        <div class={`${divClassKey !== undefined ? divClassKey : "px-4 w-1/3 mb-4"}`} >
            <p class="text-f1 font-medium text-[#344054] mb-1.5">{label}</p>
            <div class="relative w-full" data-te-dropdown-ref>
                <button onClick={()=>setisOpen(!isOpen)} class={`w-full ${submitSelected && state[id]===''?'border border-[#F04438]':'border border-[#D0D5DD]'} rounded-lg py-2.5 px-3.5 outline-0 text-f2 text-[#818E98] text-left font-normal transition duration-150 ease-in-out err-border1`}
                    type="button" id="dropdownMenu_class_name" data-te-dropdown-toggle-ref aria-expanded="false">
                    <p class="text-f2 text-[#818E98] font-normal">{state[id]===''?placeholder:state[id]}</p>
                    <img src="/images/dropdown-icon.png" alt="icon" class="absolute top-[50%] -translate-y-[50%] dropdown-close right-3" />
                </button>
                <ul ref={ref} class={`slct_drp_dwn min-w-full m-0 ${isOpen && options?.length>0?'show':'hidden'} min-w-full [&[data-te-dropdown-show]]:block shadow-s6`}
                    aria-labelledby="dropdownMenu_class_name"
                    data-te-dropdown-menu-ref>
                    {isSearch && options?.length>0 &&<li>
                        <div class="relative w-full">
                            <label for="input"></label>
                            <input  
                                value={search} 
                                onChange={(e)=>setsearch(e.target.value)} 
                                type="text" class={`w-full pl-3.5 pr-11 py-[7px] placeholder:text-f2 placeholder:text-[#818E98] placeholder:font-normal border border-[#D0D5DD] rounded-lg outline-0 text-f2 font-normal text-[#031624]`} placeholder="Search" />
                            <button class="absolute top-[50%] -translate-y-[50%] right-2">
                                <img loading="lazy" decoding="async" src="/images/search.svg" alt="img" class="w-[16px] h-[18px]" />
                            </button>
                        </div>
                    </li>}
                    <li>
                        {isSearch?
                            <ul class="max-h-[150px] overflow-auto scroll-bar mt-1">
                                {options?.length>0 && SearchArrayData(search,options).map((val,i)=>(
                                    <li key={i} onClick={()=>{
                                        handleDropdown(id,val);
                                        setisOpen(false)
                                    }}>
                                        <a class="block w-full whitespace-nowrap bg-white pl-2.5 py-1.5 text-f2 font-normal text-[#031624]"
                                            href="javascript:void(0)" data-te-dropdown-item-ref>
                                            {val}
                                        </a>
                                    </li>
                                    
                       
                                ))}
                                {options?.length>0 &&search?.length>0 && SearchArrayData(search,options)?.length===0 &&
                                (
                                    <li>
                                        <a class="block w-full whitespace-nowrap bg-white pl-2.5 py-1.5 text-f2 font-normal text-[#031624]"
                                            href="javascript:void(0)" data-te-dropdown-item-ref>
                                            No Exact macth found                                        </a>
                                    </li>
                                )}
                            </ul>
                            :
                            <ul class="max-h-[150px] overflow-auto scroll-bar mt-1">
                                {
                                    options?.length>0 && options.map((val,i)=>(
                                        <li key={i} onClick={()=>{
                                            handleDropdown(id,val);
                                            setisOpen(false)
                                        }}>
                                            <a class="block w-full whitespace-nowrap bg-white pl-2.5 py-1.5 text-f2 font-normal text-[#031624]"
                                                href="javascript:void(0)" data-te-dropdown-item-ref>
                                                {val}
                                            </a>
                                        </li>
                   
                                    )) }
                            </ul>}
                    </li>
                </ul>
            </div>
            {/* <!-- error message --> */}
            {submitSelected && state[id]==='' && <ErrorMessage error message={message} classKey="text-f1 font-normal text-[#F04438] add-error2 pt-1.5" />}
        </div>
    )
}
